import Bowser from "bowser";

export default function() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const validBrowser = !browser.isBrowser("Internet Explorer");

    if (validBrowser) {
        return true;
    }

    document.body.setAttribute('class', '');
    document.body.style.overflow = 'hidden';
    document.body.innerHTML = `<div class="browser-not-supported">
        <div class="browser-not-supported__center">
            <img class="browser-not-supported__logo" src="/img/browser-logos/stellantis-and-you-logo-white.png" alt="Stellantis &You UK">
            <h1 class="browser-not-supported__h1">Hi, Stellantis &You UK no longer supports this browser.</h1>
            <h2 class="browser-not-supported__h2">Please click on one of the icons below to download an up-to date version.<br>Sorry for any inconvenience.</h2>
            <table class="browser-not-supported__table">
                <tbody>
                    <tr>
                        <td class="browser-not-supported__td"><a href="https://www.google.co.uk/chrome/"><img src="/img/browser-logos/chrome.png" alt="Chrome"></a></td>
                        <td class="browser-not-supported__td"><a href="https://www.mozilla.org/en-GB/firefox/new/"><img src="/img/browser-logos/firefox.png" alt="Firefox"></a></td>
                        <td class="browser-not-supported__td"><a href="https://www.microsoft.com/en-gb/edge"><img src="/img/browser-logos/edge.png" alt="Edge"></a></td>
                        <td class="browser-not-supported__td"><a href="https://support.apple.com/downloads/safari"><img src="/img/browser-logos/safari.png" alt="Safari"></a></td>
                        <td class="browser-not-supported__td"><a href="https://www.opera.com/"><img src="/img/browser-logos/opera.png" alt="Opera"></a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>`;

    return false;
}